<template>
    <span class="staff">{{ title }}</span>
</template>

<script>
export default {
    props: {
        employee: Object
    },
    computed: {
        title: function() { return this.employee?.title }
    }
}
</script>